import React from 'react'
import { Modal } from 'rsuite'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'

export default function AlertWidget({
  title = 'แจ้งเตือน',
  closeBtn = 'ปิด',
  size = 'xs',
  backdrop = 'static',
  ...props
}) {
  const { show, onClose, detail } = props

  return (
    <Modal backdrop={backdrop} size={size} show={show} onHide={onClose}>
      <Modal.Header>
        <Modal.Title>
          <p style={{ paddingTop: '0.5rem' }}>{title}</p>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body> {detail} </Modal.Body>

      <Modal.Footer>
        <div>
          <CancelButton style={{}} onClick={onClose} children={closeBtn} />
        </div>
      </Modal.Footer>
    </Modal>
  )
}
